import React, { createContext, ReactNode, useContext, useMemo } from "react";
import { IFrameAPI } from "../api";

const notInNoFramingEnvironment = () => {
    throw new Error(
        "Not in no-framing sandbox environment. Action not available."
    );
};

const NoFramingSandboxIframeActionsContext = createContext<IFrameAPI>({
    getWorkspaceDetails: notInNoFramingEnvironment,
    recordActivity: notInNoFramingEnvironment,
    getCurrentWorkspaceProductTrials: notInNoFramingEnvironment,
    getCurrentWorkspace: notInNoFramingEnvironment,
    executeQuickLink: notInNoFramingEnvironment,
    addWorkspaceMember: notInNoFramingEnvironment,
    getCurrentUser: notInNoFramingEnvironment,
    getEnv: notInNoFramingEnvironment,
    updateWorkspaceMember: notInNoFramingEnvironment,
    getNoFramingFlags: notInNoFramingEnvironment,
    getStartupMode: notInNoFramingEnvironment,
    getResumeExperience: notInNoFramingEnvironment,
    trackEvent: notInNoFramingEnvironment,
    logout: notInNoFramingEnvironment,
    buyerAgentCreateSession: notInNoFramingEnvironment,
    buyerAgentGetSession: notInNoFramingEnvironment,
    buyerAgentUpdateContext: notInNoFramingEnvironment,
    buyerAgentChatStream: notInNoFramingEnvironment,
    buyerAgentMatchPersona: notInNoFramingEnvironment,
    buyerAgentGetTours: notInNoFramingEnvironment,
    buyerAgentStartTourSession: notInNoFramingEnvironment,
    buyerAgentGetTourSession: notInNoFramingEnvironment,
    buyerAgentUpdateTourProgress: notInNoFramingEnvironment,
    buyerAgentExitTourSession: notInNoFramingEnvironment,
    buyerAgentSubmitTourFeedback: notInNoFramingEnvironment,
});

interface NoFramingSandboxIframeActionsProviderProps {
    children: ReactNode;
    iframeActions: IFrameAPI;
}

export const NoFramingSandboxIframeActionsProvider: React.FC<
    NoFramingSandboxIframeActionsProviderProps
> = ({ children, iframeActions }) => {
    const contextValue = useMemo(() => iframeActions, [iframeActions]);

    return (
        <NoFramingSandboxIframeActionsContext.Provider value={contextValue}>
            {children}
        </NoFramingSandboxIframeActionsContext.Provider>
    );
};

export const useNoFramingSandboxIframeActions = (): IFrameAPI => {
    const context = useContext(NoFramingSandboxIframeActionsContext);
    if (!context) {
        throw new Error(
            "useNoFramingSandboxIframeActions must be used within an IFrameActionsProvider"
        );
    }
    return context;
};
